import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className={`font-heading text-base font-bold ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
            我的家庭教师
            <span className="ml-1 hidden text-xs font-normal sm:inline">解析站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                  : "text-background-50/90 hover:bg-white/15 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#characters"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            查看角色图鉴
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto grid max-w-6xl grid-cols-2 gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}